<template>
  <v-select
    v-on="$listeners"
    :menu-props="menuProps"
    v-bind="{ noDataText: $i18n.t('admin.noData'), ...$props, ...$attrs }"
    v-model="computedValue"
  >
    <template v-for="(value, key) in $scopedSlots" #[key]="scope">
      <slot :name="key" v-bind="scope" />
    </template>
    <template #message="{message}">
      <italic-subheader :translation-path="message"> </italic-subheader>
    </template>
    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-select>
</template>

<script>
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'DataInputSelect',
  components: {
    ItalicSubheader,
  },
  props: {
    value: {
      default: null,
    },
    menuProps: {
      type: Object,
      default: () => ({
        offsetY: true,
      }),
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-list-item__title {
    @include selectListElement();
  }
  .theme--light.v-icon.v-icon.v-icon--disabled {
    display: none;
  }
  .v-select__selections {
    flex-wrap: nowrap;
    input {
      display: none !important;
    }
  }
}
</style>
